import React, { useEffect, useState } from 'react'
import ModalUC from './modalUC'
import { BsFacebook, BsTwitter } from 'react-icons/bs'
import '../assets/styles/scss/common/_modal.scss'
import { Button, Input, Space, Tooltip, message } from 'antd'
import { CopyOutlined } from '@ant-design/icons'
import { getHomeImageStorage } from '../utils/localStorage'
import config from '../config'
import axiosRc from '../config/axios-rc'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { homeLogoState, isLoadingState } from '../recoil/states/default'

const SharedModal = (props) => {
    const { data } = props
    const [urlForShare, setUrlForShare] = useState(null)
    const logo = useRecoilValue(homeLogoState)
    const setIsLoading = useSetRecoilState(isLoadingState)

    const baseUrl = `https://${process.env.REACT_APP_NODE_ENV !== 'prod' ? 'uat-' : ''}jobs.redcross.or.th/jobDetail`
    const _textCopy = `${baseUrl}/${data?.orgUnitCode ?? data?.id}/${data?.id}`
    const copyToClipboard = () => {
        navigator.clipboard.writeText(urlForShare)
            .then(() => {
                message.info(`คัดลอก " ${urlForShare} " สำเร็จ`)
                console.log('Text copied to clipboard');
            })
            .catch((error) => {
                console.error('Failed to copy text: ', error);
            });
    }

    useEffect(() => {
        getShareUrl()
    }, [])

    const getShareUrl = async () => {
        setIsLoading(true)
        const homeImage = getHomeImageStorage()
        const body = {
            id: data?.id,
            url: _textCopy,
            title: data?.orgUnitName ?? 'ร่วมงานกับเรา',
            description: `ประกาศรับสมัคร ตำแหน่ง ${data.positionCareerName ?? ''} ${data.orgUnitName ?? ''}` ?? 'ร่วมงานกับเรา',
            imageUrl: homeImage?.logo ? `${config.wfAttachFileEndPoint}/${homeImage?.logo}` : logo
        }

        const resSave = await axiosRc.post(`Share/share_link`, body);
        if (resSave.status === 201) {
            setUrlForShare(`${config.rcAttachFileEndPoint}${resSave.data.linkHtml}`)
        }
        setIsLoading(false)
    }

    const share = async (type = 'fb') => {
        let _url = '';
        if (type === 'twitter') {
            _url = `https://twitter.com/share?url=${encodeURIComponent(urlForShare)}&text=${encodeURIComponent(data?.orgUnitName ?? '')}`;
        } else if (type === 'fb') {
            _url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlForShare)}`
        } else {
            return urlForShare
        }
        window.open(_url, '_blank');
    }

    const shareToFacebook = async () => {
        await share('fb')
    };

    const shareToTwitter = async () => {
        await share('twitter')
    };

    const childModal = () => {
        return (
            <div className='text-center shared-modal'>
                <div className="text-3-xl title mb-6">แชร์</div>
                <div className="flex shared-icon margin-auto justify-center">
                    <div className='mr-6 icon-facebook cursor-pointer' onClick={() => shareToFacebook()}>
                        <BsFacebook />
                    </div>
                    <div className='icon-twitter cursor-pointer' onClick={() => shareToTwitter()}>
                        <BsTwitter />
                    </div>
                </div>
                <div className="my-6 input-copy">
                    <Space direction="horizontal" className='w-full'>
                        <Input
                            title={_textCopy}
                            disabled={true}
                            value={_textCopy}
                        />
                        <Tooltip title={`Copy ${_textCopy}`}>
                            <Button className='btn-copy' icon={<CopyOutlined />} onClick={copyToClipboard} />
                        </Tooltip>
                    </Space>
                </div>
            </div>
        )
    }

    return (
        <ModalUC
            {...props}
            className={'modal-shared'}
            centered={true}
            showSave={false}
            labelCancel={'ปิด'}
            // showCancel={false}
            children={childModal()}
        />
    )
}

export default SharedModal